<template>
  <header
    class="PageHeader header sticky top-0 w-full z-header"
  >
    <!-- * * * * * * * mobile -->
    <div
      class="desk:hidden h-[52px]
    bg-lightest shadow-bottomLine
    flex justify-between items-center
"
    >
      <div class="flex-1 flex flex-row justify-start items-center gap-12">
        <div class="pl-12">
          <button
            class="w-24 h-24 flex items-center"
            :title="$t('header.menu.open')"
            type="button"
            @click="openMenu"
          >
            <img
              src="/icons/menu.svg"
              class="w-24 h-24"
              :alt="$t('header.menu')"
            >
          </button>
        </div>
      </div>
      <nuxt-link :to="homeUrl()" class="absolute top-0 left-half -translate-x-half w-[58px]">
        <img
          :src="`/logos/${useGlobalContentStore().domainMap?.logoUrl}.svg`"
          class="w-[58px] h-[53px]"
          alt="Kährs"
        >
      </nuxt-link>
      <div class="flex-1 pr-12 gap-16 flex justify-end items-center">
        <button
          v-if="!userStore.isLoggedIn && globalContent.getIsB2b && !isB2bUserOnB2cPage && !globalContent.getIsGlobalMarket"
          class="flex items-center"
          type="button"
          @click="myPage()"
        >
          <img
            :src="isSeller ? '/icons/laptop-performance.svg' : '/icons/log-in.svg'"
            class="w-24 h-24"
            :alt="isSeller ? $t('header.sellerTools') : $t('header.myPage')"
          >
        </button>

        <LocationSelector v-if="globalContent.getNewB2CDesign" icon-only />

        <nuxt-link
          v-if="!globalContent.getIsB2b && $sbLinkCheck(globalContent.config?.findRetailerPage) && !globalContent.getIsGlobalMarket"
          :to="$sbLinkFix(globalContent.config?.findRetailerPage)"
          class="flex items-center gap-8"
        >
          <img
            :src="globalContent.getNewB2CDesign ? '/icons/shop.svg' : '/icons/location.svg'"
            class="w-24 h-24"
            :alt="$t('findRetailer.link')"
          >
        </nuxt-link>

        <button
          v-if="userStore.isLoggedIn && !userProfile.impersonatingCompany"
          class="relative bg-bg-attention w-[30px] h-[30px] border-2 border-lightest flex items-center justify-center rounded-full"
          :class="{
            'bg-bg-warning': isCustomerSuccess,
            'bg-bg-success': isSeller,
          }"
          type="button"
          @click="showDropdown = true"
        >
          <img
            :src="isCustomerSuccess ? '/icons/headset-warning.svg' : (isSeller ? '/icons/smiley-cool-success.svg' : '/icons/smiley-attention.svg')"
            class="w-[20px] h-[20px]"
            :alt="$t('header.myPage')"
          >
          <div v-if="showDropdown" class="absolute right-0 top-32 z-modals">
            <HeaderDropdown @close="showDropdown = false" />
          </div>
        </button>

        <nuxt-link
          v-if="(isSeller || isCustomerSuccess) && userProfile.impersonatingCompany"
          class="flex items-center"
          :to="isSeller ? salesUrl('dashboard') : accountUrl('dashboard')"
        >
          <div class="flex">
            <div
              class="w-[30px] h-[30px] border-2 border-lightest flex items-center justify-center rounded-full"
              :class="{
                'bg-bg-warning': isCustomerSuccess,
                'bg-bg-success': isSeller,
              }"
            >
              <img
                v-if="isSeller"
                src="/icons/smiley-cool.svg"
                class="w-[20px] h-[20px]"
              >
              <img
                v-else
                src="/icons/headset.svg"
                class="w-[20px] h-[20px]"
                :alt="$t('header.myPage')"
              >
            </div>
          </div>
        </nuxt-link>
        <button
          v-if="(isSeller || isCustomerSuccess) && userProfile.impersonatingCompany"
          class="flex items-center"
          type="button"
          @click="isCustomerSuccess ? uiStore.setShowLogInAsCustomer(true) : uiStore.setImpersonateModal(true)"
        >
          <img
            src="/icons/change-customer.svg"
            class="w-24 h-24"
            :alt="$t('header.impersonate')"
          >
        </button>
        <button
          v-else-if="(isSeller || isCustomerSuccess) && !userProfile.impersonatingCompany"
          class="flex items-center"
          type="button"
          @click="onImpersonate"
        >
          <img
            src="/icons/change-customer.svg"
            class="w-24 h-24"
            :alt="$t('header.impersonate')"
          >
        </button>
        <nuxt-link
          v-if="userStore.isLoggedIn && !userStore.isMediabankUser && (!(isSeller || isCustomerSuccess) || (isSeller || isCustomerSuccess) && userProfile.impersonatingCompany )"
          :to="accountUrl('favorites')"
          :class="{
            'hidden': isSeller || isCustomerSuccess,
          }"
        >
          <img
            src="/icons/heart.svg"
            class="w-24 h-24"
            :alt="$t('header.favorites')"
          >
        </nuxt-link>
        <CartIcon v-if="!globalContent.getIsGlobalMarket" />
      </div>
    </div>

    <!-- * * * * * * * desktop -->
    <div
      class="hidden desk:block
             h-[53px] w-full
             bg-lightest shadow-bottomLine
            relative z-modalsContent type-sm leading-single"
    >
      <div class="flex layout-container items-center justify-between h-[53px]">
        <div class="basis-1/2 flex flex-row items-center gap-8">
          <label for="desktopSearchInput">
            <img
              src="/icons/search.svg"
              class="w-24 h-24"
              :alt="$t('search.placeholder')"
            >
          </label>
          <input
            id="desktopSearchInput"
            ref="desktopSearchInput"
            v-model="search"
            type="text"
            :placeholder="$t('search.placeholder')"
            :aria-label="$t('wcag.arialabel.search')"
            autocomplete="search"
            class="w-full placeholder-opacity-100 pt-1 h-36"
            @focus="showDesktopSearch"
            @keyup.esc="closeDesktopSearch"
            @keyup.enter="goToSearchPage"
          >
        </div>
        <nuxt-link
          v-if="!uiStore.showDesktopSearch"
          :to="homeUrl()"
          class="block basis-[59px] shrink-0"
        >
          <img
            :src="`/logos/${useGlobalContentStore().domainMap?.logoUrl}.svg`"
            class="w-full h-auto"
            alt="Kährs"
          >
        </nuxt-link>
        <div
          v-if="!uiStore.showDesktopSearch"
          class="basis-1/2 flex justify-end items-center gap-16"
        >
          <nuxt-link
            v-if="!globalContent.getIsB2b && $sbLinkCheck(globalContent.config?.findRetailerPage) && !globalContent.getIsGlobalMarket"
            :to="$sbLinkFix(globalContent.config?.findRetailerPage)"
            class="flex items-center gap-8"
          >
            <img
              :src="globalContent.getNewB2CDesign ? '/icons/shop.svg' : '/icons/location.svg'"
              class="w-24 h-24"
              :alt="$t('findRetailer.link')"
            >
            <div class="py-2 whitespace-nowrap overflow-hidden overflow-ellipsis">
              {{ $t('findRetailer.link') }}
            </div>
          </nuxt-link>

          <button
            v-if="globalContent.getIsB2b && !userStore.isLoggedIn && !isSeller && !isCustomerSuccess && !globalContent.getIsGlobalMarket"
            class="flex items-center gap-8"
            type="button"
            @click="myPage()"
          >
            <img
              :src="isSeller ? '/icons/laptop-performance.svg' : '/icons/log-in.svg'"
              class="w-24 h-24"
              :alt="isSeller ? $t('header.sellerTools') : $t('header.myPage')"
            >
            <div class="py-2 whitespace-nowrap overflow-hidden overflow-ellipsis">
              {{ $t('signin.signin') }}
            </div>
          </button>

          <button
            v-if="userStore.isLoggedIn"
            class="relative flex items-center gap-8"
            type="button"
            @click="showDropdown = true"
          >
            <div
              class="bg-bg-attention w-[30px] h-[30px] border-2 border-lightest flex items-center justify-center rounded-full"
              :class="{
                'bg-bg-warning': isCustomerSuccess,
                'bg-bg-success': isSeller,
              }"
            >
              <img
                :src="isCustomerSuccess ? '/icons/headset-warning.svg' : isSeller ? '/icons/smiley-cool-success.svg' : '/icons/smiley-attention.svg'"
                class="w-[20px] h-[20px]"
                :alt="$t('header.myPage')"
              >
            </div>
            <div class="py-2 whitespace-nowrap overflow-hidden overflow-ellipsis">
              {{ userStore.userProfile.firstName }} {{ userStore.userProfile.lastName }}
            </div>
            <div v-if="showDropdown" class="absolute right-0 top-32 z-modals">
              <HeaderDropdown @close="showDropdown = false" />
            </div>
          </button>

          <button
            v-if="(isSeller || isCustomerSuccess) && !userProfile.impersonatingCompany"
            class="flex items-center gap-8"
            type="button"
            @click="onImpersonate"
          >
            <img
              src="/icons/change-customer.svg"
              class="w-24 h-24"
              :alt="$t('header.impersonate')"
            >
            {{ $t('siteNotice.changeSalon.customerSuccess') }}
          </button>

          <button
            v-if="(isSeller || isCustomerSuccess) && userProfile.impersonatingCompany"
            class="flex items-center gap-8"
            type="button"
            @click="isCustomerSuccess ? uiStore.setShowLogInAsCustomer(true) : uiStore.setImpersonateModal(true)"
          >
            <img
              src="/icons/change-customer.svg"
              class="w-24 h-24"
              :alt="$t('header.impersonate')"
            >
            {{ $t('siteNotice.changeSalon.customerSuccess') }}
          </button>

          <nuxt-link
            v-if="userStore.isLoggedIn && !userStore.isMediabankUser && (!(isSeller || isCustomerSuccess) || (isSeller || isCustomerSuccess) && userProfile.impersonatingCompany )"
            class="flex items-center gap-8"
            :class="{
              'hidden': isCustomerSuccess || isSeller,
            }"
            :to="isSeller ? salesUrl('favorites') : accountUrl('favorites')"
          >
            <img
              src="/icons/heart.svg"
              class="w-24 h-24"
              :alt="$t('header.favorites')"
            >
            <div class="mobOnly:hidden py-2 whitespace-nowrap overflow-hidden overflow-ellipsis">
              {{ $t('header.favorites') }}
            </div>
          </nuxt-link>

          <CartIcon v-if="!globalContent.getIsGlobalMarket" />
        </div>
        <button
          v-if="uiStore.showDesktopSearch"
          class="flex items-center"
          type="button"
          @click="closeDesktopSearch"
        >
          <div class="mr-12">{{ $t('search.cancel') }}</div>
          <img
            src="/icons/close.svg"
            class="w-24 h-24"
            :alt="$t('search.cancel')"
          >
        </button>
      </div>
      <transition name="fade">
        <div
          v-show="uiStore.showDesktopSearch"
          class="relative"
          @keyup.esc="closeDesktopSearch"
        >
          <div class="absolute top-0 left-0 w-full bg-lightest border-t border-light searchResultHeight">
            <SearchResult
              v-if="uiStore.searchOpenedOnceDesk"
              :search="search"
              @select="(e) => search = e"
              @go-to-search-page="goToSearchPage"
            />
          </div>
        </div>
      </transition>
    </div>
  </header>
</template>

<script setup lang="ts">
import { useUiStore } from '~/store/ui';
import CartIcon from '~/components/cart/CartIcon.vue';
import useLinkReplacer from '~/composables/useLinkReplacer';
import { useUserStore } from '~/store/user';
import { storeToRefs } from 'pinia';
import SearchResult from '~/components/search/SearchResult.vue';
import { useGlobalContentStore } from '~/store/globalContent';
import HeaderDropdown from '~/components/body/HeaderDropdown.vue';
import LocationSelector from '~/components/menu/LocationSelector.vue';
const globalContent = useGlobalContentStore();

const { accountUrl, manualUrl, salesUrl, homeUrl } = useLinkReplacer();

const { $t } = useNuxtApp();
const uiStore = useUiStore();
const userStore = useUserStore();

const { userProfile } = storeToRefs(userStore);

const showDropdown = ref(false);

const openMenu = () => {
  uiStore.sideMenuParents = [];
  uiStore.setShowSideMenu(true);
};

const myPage = () => {
  if (isCustomerSuccess.value && !userStore.userProfile.impersonatingCompany) {
    navigateTo(accountUrl('selectCustomer'));
  } else {
    if (userStore.loggedIn) {
      navigateTo(isSeller.value ? salesUrl('dashboard') : accountUrl('dashboard'));
    } else {
      uiStore.setShowSigninModal(true);
    }

  }
};

const onImpersonate = () => {
  if (isCustomerSuccess.value) {
    uiStore.setShowLogInAsCustomer(true);
  } else {
    uiStore.setImpersonateModal(true);
  }

};

const search = ref('');

const desktopSearchInput = ref<HTMLElement>();
const closeDesktopSearch = () => {
  search.value = '';
  uiStore.showDesktopSearch = false;
  desktopSearchInput.value?.blur();
};

const goToSearchPage = () => {
  uiStore.showDesktopSearch = false;
  desktopSearchInput.value?.blur();
  navigateTo(manualUrl(`/search?q=${search.value}`));
  search.value = '';
};

const isSeller = computed(() => {
  return userStore.isSalesRepUser;
});

const isCustomerSuccess = computed(() => {
  return userStore.isCustomerSuccessUser;
});

const isCountryManager = computed(() => {
  return userStore.isCountryManagerUser;
});

const myPagesText = computed(() => {
  if (isCountryManager.value) {
    return $t('header.countryManagerTools');
  } else if (isSeller.value) {
    return $t('header.sellerTools');
  } else if (isCustomerSuccess.value) {
    return userStore.userProfile.impersonatingCompany ? userStore.userProfile.company.name : $t('header.customerSuccessImpersonate');
  } else if (userStore.isLoggedIn) {
    return userStore.userProfile.company.name;
  } else {
    return $t('header.myPage');
  }
});

const showDesktopSearch = () => {
  uiStore.searchOpenedOnceDesk = true;
  uiStore.showDesktopSearch = true;
};

// Hide login when B2B user is viewing B2C page
const route = useRoute();
const isB2bUserOnB2cPage = computed(() => {
  const b2bBasePath = globalContent.domainMap?.b2b?.storyblokBasePath;
  if (!b2bBasePath || !globalContent.getIsB2b) { return false; }
  return !route.path.includes(`/${b2bBasePath}/`) && !route.path.includes(`/${b2bBasePath}`);
});

</script>

<style scoped lang="postcss">
.searchResultHeight {
  max-height: calc(100vh - 53px); /* entire screen - header */
  height: calc(100vh - 53px);
  @apply overflow-auto pb-64;
  /* padding bottom, at least 32 for if sitemessages are hidden */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
